import React from "react";
import { Link } from "react-router-dom";
import { FiMapPin, FiMaximize } from "react-icons/fi";
import { IoBedOutline } from "react-icons/io5";
import { LuBath, LuCar } from "react-icons/lu";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { useApp } from "../context/AppContext";

export default function Card({ property }) {
  const { toggleFavorite, isFavorite, user } = useApp();
  const fav = isFavorite(property.id);

  const timeAgo = () => {
    const days = Math.floor(
      (new Date() - new Date(property.dateAdded)) / (1000 * 60 * 60 * 24)
    );
    if (days === 0) return "Today";
    if (days === 1) return "Yesterday";
    return `${days} days ago`;
  };

  return (
    <div className="property-card">
      <div className="card-img-wrapper">
        <img src={property.image} alt={property.title} />
        <span className={`card-badge ${property.status === "For Sale" ? "sale" : "rent"}`}>
          {property.status}
        </span>
        {property.featured && (
          <span className="card-badge featured">★ Featured</span>
        )}
        {user && (
          <button
            className={`favorite-btn ${fav ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              toggleFavorite(property.id);
            }}
            title={fav ? "Remove from favorites" : "Add to favorites"}
          >
            {fav ? <FaHeart /> : <FaRegHeart />}
          </button>
        )}
      </div>

      <div className="card-body-custom">
        <div className="property-price">
          ${property.price.toLocaleString()}
        </div>
        <h6 className="property-title">{property.title}</h6>
        <div className="property-location">
          <FiMapPin size={14} />
          {property.location}, Kigali
        </div>

        <div className="property-features">
          {property.bedrooms > 0 && (
            <div className="feature-item">
              <IoBedOutline size={16} />
              <span>{property.bedrooms} Beds</span>
            </div>
          )}
          <div className="feature-item">
            <LuBath size={15} />
            <span>{property.bathrooms} Baths</span>
          </div>
          <div className="feature-item">
            <LuCar size={15} />
            <span>{property.parking}</span>
          </div>
          <div className="feature-item">
            <FiMaximize size={14} />
            <span>{property.area} m²</span>
          </div>
        </div>
      </div>

      <div className="card-footer-custom">
        <Link className="btn-view" to={`/property/${property.id}`}>
          View Details
        </Link>
        <span className="time-ago">{timeAgo()}</span>
      </div>
    </div>
  );
}
